import { tcl, plex, ronin, androidtv, appletv, samsung, roku, sony, lg } from 'images';

const data = [
    {
        src: tcl,
    },
    {
        src: plex,
    },
    {
        src: ronin,
    },
    {
        src: androidtv,
    },
    {
        src: appletv,
        className: 'apple',
    },
    {
        src: samsung,
    },
    {
        src: roku,
    },
    {
        src: sony,
    },
    {
        src: lg,
    },
];

export default data;
